import React from 'react';
import { flowRight as compose } from 'lodash';
import cx from 'classnames';

import withStyles from 'isomorphic-style-loader/withStyles';

// Components
import DetailSearchForm from '../DetailSearchForm/DetailSearchForm';

import s from './Layout4.css';

const Layout4 = ({ title, content, homeBannerImages, isLoading }) => {

  const path = '/images/home/';
  const homeBannerFirst = homeBannerImages?.[0]?.name ? path + homeBannerImages[0].name : '';

  return (
    <div>
      <div className={cx(s.bannerLayoutContainer)}>
        <div
          className={cx(s.bannerBackgroundImage)}
          style={{ backgroundImage: `url(${homeBannerFirst})` }}
        />
        <div className={s.searchFormContainer}>
          <div className={cx(s.searchFormWrap, 'commonWordBreak')}>
            <h1>
              <span>{title}</span>
              <span>{content} </span>
            </h1>
            <DetailSearchForm isLoading={isLoading} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default compose(withStyles(s))(Layout4);